<script>
    import Modal from "sv-bootstrap-modal";
    import { portraitPolicyOpen } from "../../utilities/DataStore";
</script>

<style>
    .liteon-policy h2 {
        font-size: 1.5rem;
        font-weight: bold;
    }

    .liteon-policy h4 {
        font-size: 1.25rem;
    }

    .liteon-policy label {
        font-size: 0.85rem;
    }

    .liteon-policy p {
        font-size: 0.95rem;
    }

    .liteon-policy .policy-updated {
        font-size: 0.75rem;
    }
</style>

<Modal bind:open={$portraitPolicyOpen} dialogClasses="modal-xl">
    <div class="modal-header">
        <h5 class="modal-title">
            LITEON Portrait Rights Policy
        </h5>
        <button
            type="button"
            class="close"
            on:click={() => portraitPolicyOpen.update((x) => false)}
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body liteon-policy">
        <h2>測驗參與者肖像與聲音同意書</h2>
        <p>
            為進行本次測驗，光寶科技股份有限公司將可能記錄您的影像、聲音與畫面，以作為內部評估與紀錄之用。
        </p>
        <p>
            本人同意光寶科技股份有限公司（以下簡稱「光寶科技」）拍攝本人之肖像，錄製影像與聲音，僅供內部用途。
        </p>
        <p>
            上述影像與聲音資料僅供光寶科技內部使用，保存期限為三年，自拍攝日起算。期滿後，光寶科技將妥善刪除或銷毀相關視聽資料。其他測驗相關資料將依光寶科技內部資料保存政策持續保存。
        </p>

        <h2>
            Consent Form for Portrait and Audio Recording of Assessment
            Participants
        </h2>
        <div class="policy-updated">Last Updated: January 1, 2021</div>
        <p>
            As part of this assessment, your image, video, and voice may be
            recorded for internal evaluation and documentation purposes.
        </p>
        <p>
            I hereby consent to the photographing, video recording, and audio
            recording of my likeness and voice by LITEON Technology Corporation
            ("LITEON") for internal purposes only.
        </p>
        <p>
            Image and audio/video materials will be kept for 3 years from the date of capture and then deleted or destroyed. Other assessment data
            will be retained per LITEON's internal policy.
        </p>

        <div class="modal-footer">
            <button
                type="button"
                class="btn btn-primary"
                on:click={() => portraitPolicyOpen.update((x) => false)}
                >Close</button
            >
        </div>
    </div>
</Modal>
